
import { mapGetters } from 'vuex'
export default {
  name: 'FormCard',
  directives: {
    'number-only': {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, '')
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true
          }
          event.preventDefault()
        }
        el.addEventListener('keypress', checkValue)
      },
    },
    'letter-only': {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault()
          }
          return true
        }
        el.addEventListener('keypress', checkValue)
      },
    },
  },
  props: {
    actionCard: {
      type: Function,
      default: () => {},
    },
    actionVolta: {
      type: Function,
      default: () => {},
    },
    bandeira: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {
        return {
          nomeImpresso: '',
          parcelas: '',
          numeroCartao: '',
          cardNumberNotMask: '',
          dataExpiracao: '',
          codigoSeguranca: '',
        }
      },
    },
  },
  data() {
    return {
      fields: {
        codigoSeguranca: 'v-card-cvv',
      },
      isCardNumberMasked: true,
      cardNumberMaxLength: 19,
      rulesInputDataExpiracao: [
        (v) => !!v || 'Data Expiração obrigatório',
        (v) =>
          /^(0[1-9]|1[0-2])\/(19|20)\d{2}$/.test(v) ||
          'A data deve ser "MM/AAAA"',
      ],
      rulesInputCard: [(v) => !!v || 'Campo é obrigatório'],
      rulesInputCardNumber: [
        (v) => !!v || 'Campo é obrigatório',
        (v) => /^\d{4} \d{4} \d{4} \d{4}$/.test(v) || 'Numero do cartão',
      ],
      rulesInputCardCvv: [(v) => !!v || 'Obrigatório'],
    }
  },

  computed: {
    ...mapGetters('cart', ['totalCartPrice']),
    parcelas() {
      if (!this.totalCartPrice) return []
      const totalAmount = this.totalCartPrice
      let parcelasArray
      if (totalAmount < 100) {
        parcelasArray = [1]
      } else if (totalAmount >= 100 && totalAmount < 150) {
        parcelasArray = [1, 2]
      } else {
        parcelasArray = [1, 2, 3]
      }
      return parcelasArray.map((item) => {
        const valor = totalAmount / item

        return {
          text: `${item}x de R$ ${valor.toFixed(2)} sem Juros`,
          value: item,
        }
      })
    },
  },

  methods: {
    generateMonthValue(n) {
      return n < 10 ? `0${n}` : n
    },
    changeName(value) {
      this.formData.nomeImpresso = value
      this.$emit('input-card-name', this.formData.nomeImpresso)
    },
    changeNumber(value) {
      this.formData.numeroCartao = value
      const e = this.formData.numeroCartao.replace(/\D/g, '')
      // american express, 15 digits
      if (/^3[47]\d{0,13}$/.test(e)) {
        this.formData.numeroCartao = e
          .replace(/(\d{4})/, '$1 ')
          .replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 17
      } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(e)) {
        // diner's club, 14 digits
        this.formData.numeroCartao = e
          .replace(/(\d{4})/, '$1 ')
          .replace(/(\d{4}) (\d{6})/, '$1 $2 ')
        this.cardNumberMaxLength = 16
      } else if (/^\d{0,16}$/.test(e)) {
        // regular cc number, 16 digits
        this.formData.numeroCartao = e
          .replace(/(\d{4})/, '$1 ')
          .replace(/(\d{4}) (\d{4})/, '$1 $2 ')
          .replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ')
        this.cardNumberMaxLength = 19
      }
      // eslint-disable-next-line eqeqeq
      if (e.inputType == 'deleteContentBackward') {
        const lastChar = this.formData.numeroCartao.substring(
          this.formData.numeroCartao.length,
          this.formData.numeroCartao.length - 1
        )
        // eslint-disable-next-line eqeqeq
        if (lastChar == ' ') {
          this.formData.numeroCartao = this.formData.numeroCartao.substring(
            0,
            this.formData.numeroCartao.length - 1
          )
        }
      }
      this.$emit('input-card-number', this.formData.numeroCartao)
    },
    changeDate() {
      this.$emit('input-card-date', this.formData.dataExpiracao)
    },
    changeCvv(value) {
      this.formData.codigoSeguranca = value
      this.$emit('input-card-cvv', this.formData.codigoSeguranca)
    },
  },
}
